import { createWebsiteModule } from './websiteHostModule';
import { createHost } from './hostPlatform';
export const site = createWebsiteModule({
  createHost
});
export * from './types';
//# sourceMappingURL=index.js.map